const ENVS = {
  api: [
    { name: 'prod', host: process.env.VUE_APP_API_HOST, key: process.env.VUE_APP_APIKEY },
    { name: 'dev', host: process.env.VUE_APP_API_HOST_DEV, key: process.env.VUE_APP_APIKEY_DEV },
  ],
  ui: [
    { name: 'prod', host: process.env.VUE_APP_UI_HOST },
    { name: 'dev', host: process.env.VUE_APP_UI_HOST_DEV },
  ],
  /**
    Mock scan type
    0: no mock
    1: Gen2 (2-step)
    2: Gen2 (1-step)
    3: Gen1 (2-step)
    4: Gen1 (1-step)
   */
  mock: 0,
};

// Check current location and see if the app should be in DEV mode initially
// (criteria: localhost, ip address, or defined in ENV)
const IP_ADDRESS_REGEXP = /\b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.?){4}\b/gi;
const currentHost = window.location.host;
const devHOST = ENVS.ui[1].host;
// default to prod env if the app is running from files
const hostFromFiles = !window.location.protocol?.startsWith('http') ?? false;
console.log('running from files: ', hostFromFiles);
const isDev =
  currentHost === 'localhost' ||
  IP_ADDRESS_REGEXP.test(currentHost) ||
  (devHOST && devHOST.indexOf(currentHost) > -1);
export const INITIAL_INDEX = isDev && !hostFromFiles ? 1 : 0;

export default ENVS;
